import { FormItem, SelectInput } from '@framework/form';
import { CandidateColumns } from '../table/CandidateColumns';

export interface ICandidateColumnSelectInputProps {
  name: string;
  label: string;
  help: string;
  placeholder?: string;
}

export const columnsOptions = CandidateColumns.map(col => ({
  value: col.name,
  label: col.label,
}));

/**
 * Componente di selezione delle colonne dei membri della lista elettorale
 */
export function CandidateColumnSelectInput(
  props: ICandidateColumnSelectInputProps,
) {
  const { name, label, help, placeholder } = props;

  return (
    <FormItem name={name} label={label} help={help}>
      <SelectInput
        name={name}
        mode="multiple"
        options={columnsOptions}
        placeholder={placeholder}
      />
    </FormItem>
  );
}
